import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Link,
  useParams,
  useNavigate,
  createSearchParams,
} from "react-router-dom";
import { makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  TextField,
  InputLabel,
  Input,
  Button,
  Autocomplete,
} from "@mui/material";
import {
  searchRecords,
  listRecordCategories,
  deleteRecord,
} from "../actions/VivoFinanceActions";
import LoadingBox from "../components/LoadingBox";
import MessageBox from "../components/MessageBox";
import { reportperiod } from "../utils";
import SearchedRecord from "../components/SearchedRecord";
import styles from "assets/jss/vivoleo-react-kit/views/landingPageSections/RecordSearchScreenStyle";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { RECORD_DELETE_RESET } from "../constants/financeConstants";
import Notification from "../components/Notification";
import ConfirmDialog from "../components/ConfirmDialog";

const useStyles = makeStyles(styles);

export default function RecordSearchScreen(props) {
  const useNavigateSearch = () => {
    const navigate = useNavigate();
    return (pathname, params) =>
      navigate({ pathname, search: `?${createSearchParams(params)}` });
  };
  const classes = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const option1 = "cloudrent";
  let { category } = useParams();
  const [searchCategory, setSearchCategory] = useState(category);
  //const [category, setCategory] = useState(propscategory);
  const dispatch = useDispatch();
  const dispatch2 = useDispatch();
  const recordSearch = useSelector((state) => state.recordSearch);
  const { loading, error, records } = recordSearch;
  console.log("records:" + records);
  const recordCategoryList = useSelector((state) => state.recordCategoryList);
  const {
    loading: loadingCategories,
    error: errorCategories,
    summary: recordcategories,
  } = recordCategoryList;
  console.log("recordCategoryList:" + recordCategoryList);
  console.log("categories:" + recordcategories);
  const recordDelete = useSelector((state) => state.recordDelete);
  const {
    loading: loadingDelete,
    error: errorDelete,
    success: successDelete,
  } = recordDelete;

  useEffect(() => {
    dispatch({ type: RECORD_DELETE_RESET });
    dispatch(
      searchRecords({
        category: category !== "All" ? category : "",
      })
    );
    dispatch2(listRecordCategories());
  }, [dispatch, dispatch2, category, successDelete]);

  const onDelete = (record) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    // if (window.confirm('Are you sure to delete?')) {
    dispatch(deleteRecord(record._id));
    setNotify({
      isOpen: true,
      message: "Records Deleted Successfully",
      type: "success",
    });

    // }
  };
  const getFilterUrl = (filter) => {
    const filterCategory = filter.category || category;
    return `/searchrecord/category/${filterCategory}`;
    //const redirect = "/searchrecord/category/${filterCategory}";
    //   navigate( "/searchrecord/category/", search:${filterCategory});
    //navigate(`/searchrecord/category/${filterCategory}`);
  };
  /*
  const navigateSearch = useNavigateSearch();

  const getFilterUrl = (filter) => {
    const filterCategory = filter.category || propscategory;
    navigateSearch("/searchrecord/category/", { filterCategory });
  };
*/
  return (
    <div>
      <div className={classes.space30}> </div>
      <GridContainer justify="center" className={classes.contentText}>
        <GridItem xs={12} sm={12} md={4} className={classes.topSpace}>
          {loadingDelete && <LoadingBox></LoadingBox>}
          {errorDelete && (
            <MessageBox variant="danger">{errorDelete}</MessageBox>
          )}
          {loadingCategories ? (
            <LoadingBox></LoadingBox>
          ) : errorCategories ? (
            <MessageBox variant="danger">{errorCategories}</MessageBox>
          ) : (
            <>
              <div className={classes.textCenter}>
                <h3>Search Record</h3>
              </div>
              <Autocomplete
                id="category"
                freeSolo
                options={recordcategories.categories.map((x) => x.category)}
                sx={{ width: 300 }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Category "
                    defaultValue={searchCategory}
                    helperText="Select one Category or input new Category "
                    variant="standard"
                    required
                  />
                )}
                // onChange={(e) => setDescription(value)}
                onChange={(event, newValue) => {
                  navigate(getFilterUrl({ category: newValue }), {
                    replace: true,
                  });
                  setSearchCategory(newValue);
                }}
                onInputChange={(event, newInputValue) => {
                  navigate(getFilterUrl({ category: newInputValue }), {
                    replace: true,
                  });
                  setSearchCategory(newInputValue);
                }}
              />
            </>
          )}
        </GridItem>
        <GridItem xs={12} sm={12} md={8} className={classes.topSpace}>
          {loading ? (
            <LoadingBox></LoadingBox>
          ) : error ? (
            <MessageBox variant="danger">{error}</MessageBox>
          ) : (
            <>
              <div className="row center">
                {records.records.length > 0 ? (
                  <>
                    <div className={classes.space30}> </div>
                    <div className={classes.space30}> </div>

                    <h5>Category: {searchCategory} </h5>
                    <div>
                      Total:
                      {records.records.length} Searched Records
                    </div>
                  </>
                ) : (
                  <MessageBox>No Records Found</MessageBox>
                )}

                {records.records.length > 0 ? (
                  records.records.map((x) => (
                    <>
                      <SearchedRecord key={x._id} record={x}></SearchedRecord>
                      <Button
                        variant="outlined"
                        className="medium"
                        startIcon={<DeleteIcon sx={{ color: "#E91E63" }} />}
                        onClick={() => {
                          setConfirmDialog({
                            isOpen: true,
                            title: "Are you sure to delete the record?",
                            subTitle:
                              "You can't UNDO this operation once you click YES!",
                            onConfirm: () => {
                              onDelete(x);
                            },
                          });
                        }}
                      >
                        Delete
                      </Button>
                    </>
                  ))
                ) : (
                  <MessageBox>No Records Found</MessageBox>
                )}
              </div>
            </>
          )}
        </GridItem>
      </GridContainer>
      <div className={classes.space30}> </div>
      <Notification notify={notify} setNotify={setNotify}></Notification>
      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog}
      />
    </div>
  );
}
